import { render } from "./Teeth.vue?vue&type=template&id=091f9619"
import script from "./Teeth.vue?vue&type=script&lang=js"
export * from "./Teeth.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__